'use client';

import { NavButtonLink, Stack } from '@/primitives';
import { useShell } from '@/providers';
import { NavItem } from './ShellNavItems';
import { blue } from '@/lib/colours';
import { registrySidebarLightRailForeground } from '@/lib/registrySidebarRail';
import { registrySidebarDarkBackground } from '@/lib/registrySidebarDarkBg';
import { forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { useResolvedColorScheme } from '@/hooks/useResolvedColorScheme';

interface Props {
  items: NavItem[];
}

export default forwardRef<HTMLDivElement, Props>(function ShellSubNavItems(
  { items }: Props,
  ref,
) {
  const theme = useTheme();
  const { isDarkMode } = useResolvedColorScheme();
  const { sidebarExpanded } = useShell();

  return (
    <Stack
      ref={ref}
      sx={{
        gap: 1,
        borderLeft: '2px solid',
        borderColor: isDarkMode
          ? 'primary.main'
          : registrySidebarLightRailForeground,

        ...(sidebarExpanded
          ? {
              // Align tree line with main nav icons: NavButtonLink mx (8px) + pl (5px) + startIcon padding (3px)
              ml: '16px',
              width: 'calc(100% - 16px)',
              pl: 1.5,
            }
          : {
              ml: 0,
              width: '100%',
            }),
        maxWidth: '100%',
        boxSizing: 'border-box',
        ...(!sidebarExpanded && {
          borderRadius: '4px',
          background: isDarkMode
            ? registrySidebarDarkBackground(theme)
            : blue[900],
        }),
        '& > a': { height: '34px' },
      }}
    >
      {items.map(({ expanded, label, subnavs, ...rest }, index) => (
        <NavButtonLink isSubnav key={index} {...rest}>
          {label}
        </NavButtonLink>
      ))}
    </Stack>
  );
});
